import styled from "styled-components";
import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((_theme: Theme) => ({
    chip: {
        fontSize: 10,
        margin: '4px',
    },
    colorPrimary: {
        color: "#80f",
    },
    paper: { borderRadius: 12 },
    inputBorder: {
        borderRadius: 6,
        width: '100%',
        height: '100%',
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#8800FF',
            },
            '&:hover fieldset': {
                borderColor: '#8800FF',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#8800FF',
            },
        },
        "& input": {
            fontFamily: "DIN",
            padding: "16px",
        },
        "& input::placeholder": {
            fontFamily: "DIN",
        },
    },
    modalBackground: {
        [_theme.breakpoints.down(701)]: {
            backgroundColor: "#F5F3F6",
        }
    },
    scrollPaper: {
        alignItems: "flex-start",
    },
    rootDialog: {
        "& .MuiDialog-paper": {
            maxWidth: "678px",
            [_theme.breakpoints.down(701)]: {
                margin: 0,
                borderRadius: 0,
                height: "100%",
                padding: "4px",
                boxShadow: "none",
            },
            [_theme.breakpoints.up(701)]: {
                margin: "auto",
                borderRadius: 12,
            },
        },
    },
    dividerTop: {
        borderTop: "1px solid #EDECF2",
    },
    dividerBottom: {
        borderBottom: "1px solid #EDECF2",
    },
    channelItemRow: {
        paddingTop: _theme.spacing(1),
        paddingBottom: _theme.spacing(1),
    },
    channelImage: {
        width: 80,
    },
    formHelperText: {
        "&.MuiFormHelperText-root": {
            fontSize: 16
        }
    },
    connectButtonContainer: {
        width: 116,
    },
    warningContainer: {
        backgroundColor: "#FDF6EC",
        marginTop: _theme.spacing(1),
        paddingLeft: _theme.spacing(2),
        paddingRight: _theme.spacing(2),
        paddingTop: _theme.spacing(1.5),
        paddingBottom: _theme.spacing(1.5),
        textAlign: "left",
    },

    button: {
        display: "flex",
        color: "#ffffff",
        width: "100%",
    },
    buttonText: {
        padding: "6px 12px",
        textAlign: 'left'
    },
}));

interface MainContainerProps {
    opacity?: number;
}

interface GradientRoundedContainerProps {
    width?: string;
    height?: string;
}

interface AvatarContainerProps {
    top?: string;
}

export interface StyledLabelProps {
    fontSize?: number;
    fontWeight?: number;
    color?: string;
    cursor?: string;
    margin?: string;
    padding?: string;
    paddingLeft?: string;
    marginLeft?: string;
}

export interface StyledLabelProps {
    fontSize?: number
    fontWeight?: number
    color?: string
    cursor?: string
    margin?: string
    padding?: string
    paddingLeft?: string
    marginLeft?: string
    fontFamily?: string
}

interface StyledButtonProps {
    width?: string
}

interface SearchListContainerProps {
    height?: string
}

export const SearchListContainer = styled.div`
  width: 100%;
  height: ${({ height }: SearchListContainerProps) => height || "100%"};
  overflow-y: auto;
  overflow-x: hidden;
`

export const StyledButton = styled.button`
  width: ${({ width }: StyledButtonProps) => width || "116px"};
  color: rgba(136, 0, 255, 1);
  font-size: 16px;
  padding-left: 24px;
  padding-right: 24px;
  font-family: DIN;
  text-transform: none;
  height: 40px;
  font-weight: 600;
`

interface LeftSectionProps {
    width?: string;
    isMobile?: boolean;
}

interface RightSectionProps {
    display?: string;
}

interface ModalContainerProps {
    minHeight?: string
    height?: string
    maxHeight?: string
    width?: string
    margin?: string
    padding?: string
    gap?: string
}

interface TitleContainerProps {
    gap?: string;
}

interface ArtistImageProps {
    widthStyle?: string
    heightStyle?: string
}

export const LeftColumn = styled.div`
  width: ${({ width }: LeftSectionProps) => width};
  margin: ${({ isMobile }: LeftSectionProps) => isMobile ? '32px 16px' : '0'};
  height: ${({ isMobile }: LeftSectionProps) => isMobile ? 'fit-content' : '100%'};
  border-radius: ${({ isMobile }: LeftSectionProps) => isMobile ? '8px' : '0'};
  padding: ${({ isMobile }: LeftSectionProps) => isMobile ? '32px 16px 16px 16px' : '36px 80px 56px'};
  max-height: ${({ isMobile }: LeftSectionProps) => isMobile ? 'calc(100% - 64px)' : '100%'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ isMobile }: LeftSectionProps) => isMobile ? '32px' : '48px'};;
  background: #FFFFFF;
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: ${({ gap }: TitleContainerProps) => gap || "18px"};
`;

export const MainTitle = styled.div`
  font-family: 'DIN';
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  color: #000000;
`;

export const SubTitle = styled.div`
  font-family: 'DIN';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  opacity: 0.56;
`;

export const ArtistImage = styled.img`
  width: ${({ widthStyle }: ArtistImageProps) => widthStyle || "58px"};
  height: ${({ heightStyle }: ArtistImageProps) => heightStyle || "58px"};
  background: url("assets/images/not-found-user.png");
  border-radius: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
`

export const ArtistNameBoldLabel = styled.span`
  font-weight: 600;
`;

export const LogoContainer = styled.div`
  height: 32px;
`;

export const CreateNewArtistcontainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 10px;
  height: 158px;
  background: linear-gradient(
      0deg,
      rgba(136, 0, 255, 0.08),
      rgba(136, 0, 255, 0.08)
    ),
    #ffffff;
  border-radius: 8px;
  flex: none;
  order: 3;
  align-self: stretch;
  flex-grow: 0;
  cursor: pointer;
`

export const CreateNewArtistImage = styled.img`
  width: 80px;
  height: 80px;
  flex: none;
  order: 0;
  flex-grow: 0;
`

export const CreateNewBrandLabel = styled.div`
  height: 20px;
  font-family: "DIN";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #8800ff;
  flex: none;
  order: 1;
  flex-grow: 0;
`

export const RightColumn = styled.div`
& { 
  width: 50%;
  height: 100%;
  display: ${({ display }: RightSectionProps) => display};
  justify-content: flex-end;
  align-items: center;
  overflow-x: hidden;
  background: linear-gradient(290.62deg, #8800FF 0.13%, #D7B3ED 43.95%, #A1F0D4 74.68%);
}
&:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: -100;
  width:100%;
  height:100%;
  background: linear-gradient(269.32deg, #8800FF 18.14%, #8800FF 33.94%, rgba(161, 240, 212, 0.22) 102.22%);  
}
`;

export const LottieContainer = styled.div`
  width: 660px;
  margin-left: 60px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 23px 0 0 23px;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ padding }: ModalContainerProps) => padding || "32px"};
  gap: ${({ gap }: ModalContainerProps) => gap || "48px"};
  height: ${({ height }: ModalContainerProps) => height || "484px"};
  min-height: ${({ minHeight }: ModalContainerProps) => minHeight};
  max-height: ${({ maxHeight }: ModalContainerProps) => maxHeight};
  width: ${({ width }: ModalContainerProps) => width || "673px"};
  margin: ${({ margin }: ModalContainerProps) => margin || "auto"};
  background: #ffffff;
  border-radius: 8px;
`

export const ModalTitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
`

export const CloseButtonContainer = styled.div`
  width: 100%;
`

export const CloseIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: rgba(136, 0, 255, 0.04);
  border-radius: 50%;
  cursor: pointer;
`

export const ModalTitlesLabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  display: block;
`

export const ModalMainTitleLabel = styled.div`
  font-family: "DIN";
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  color: #000000;
`

export const ModalSubtitleLabel = styled.div`
  font-family: "DIN";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #707070;
  width: 100%;
`

export default useStyles;
